import { render, staticRenderFns } from "./commodityInformationTable.vue?vue&type=template&id=4305288a&scoped=true&"
import script from "./commodityInformationTable.vue?vue&type=script&lang=js&"
export * from "./commodityInformationTable.vue?vue&type=script&lang=js&"
import style0 from "./commodityInformationTable.vue?vue&type=style&index=0&id=4305288a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4305288a",
  null
  
)

export default component.exports